import { useEffect, useState } from "react";
import { postDataWithBody, putDataWithBody, getData, deleteDataById } from "../../../Services/Services";
import { createimageface, updateimageface, getallpersons, deleteperson, getThemeURL } from "../../../Services/EndPoints";
import { toast } from "react-toastify";
import "./FaceManagement.css";
import useModulePermissions, { FLEET_PERMISSION_IDS } from "../Common/hooks/useModulePermissions";

const UserImagesView = () => {
    // Role's Edit / Delete rights for Facial Registration (web_permissions from getUserProfile)
    const { canEdit, canDelete } = useModulePermissions(FLEET_PERMISSION_IDS.FACIAL_REGISTRATION);
    const [activeTab, setActiveTab] = useState("upload");
    const [users, setUsers] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [image, setImage] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState({});
    const [previewData, setPreviewData] = useState(null);
    const [department, setDepartment] = useState("");
    const [loading, setLoading] = useState(false);
    const [userId, setUserId] = useState(null);
    const [existingImageUrl, setExistingImageUrl] = useState(null);
    const [deleteModal, setDeleteModal] = useState({ show: false, index: null, user: null });
    const [roleType, setRoleType] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [reloadLoading, setReloadLoading] = useState(false);
    const [reloadStatus, setReloadStatus] = useState("");
    const [embeddingStatusMap, setEmbeddingStatusMap] = useState({});
    const [imagePreviewModal, setImagePreviewModal] = useState({ show: false, imageUrl: '', userName: '' });
    const [reloadConfirmModal, setReloadConfirmModal] = useState(false);



    useEffect(() => {
        fetchAllPersons();
        fetchUserProfile()
    }, []);
console.log(reloadStatus)
    // Load embedding status map from sessionStorage on component mount
useEffect(() => {
  const savedStatusMap = sessionStorage.getItem("embeddingStatusMap");
  
  if (savedStatusMap) {
    try {
      const parsedStatusMap = JSON.parse(savedStatusMap);
      setEmbeddingStatusMap(parsedStatusMap);
      console.log("Loaded embedding status map from sessionStorage:", parsedStatusMap);
    } catch (error) {
      console.error("Error parsing embedding status map from sessionStorage:", error);
      sessionStorage.removeItem("embeddingStatusMap");
    }
  }
}, []);

const handleImageClick = (imageUrl, userName) => {
    setImagePreviewModal({ show: true, imageUrl, userName });
};

const handleCloseImagePreview = () => {
    setImagePreviewModal({ show: false, imageUrl: '', userName: '' });
};


    const fetchUserProfile = async () => {
        try {
            const response = await getData(getThemeURL);
            if (response && Array.isArray(response) && response.length > 0) {
                setUserId(response[0].id);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
        }
    };

    const fetchAllPersons = async () => {
        try {
            setLoading(true);
            const response = await getData(getallpersons, {});

            if (response.status === "success" && response.data) {
                const transformedUsers = response.data.map(person => ({
                    id: person.id,
                    name: person.personName,
                    image: person.mediaPath,
                    department: person.department,
                    roleType: person.roleType,
                    contactNumber: person.contactNumber,
                    fileName: person.fileName
                }));

                setUsers(transformedUsers);
            } else {
                console.error("Failed to fetch persons:", response.msg);
            }
        } catch (error) {
            console.error("Error fetching persons:", error);
            toast.error("Failed to load data. Please refresh the page.");
        } finally {
            setLoading(false);
        }
    };



const handleReloadEmbeddings = async () => {
  setReloadLoading(true);
  setReloadStatus("Starting reload process...");
  
  try {
    // Step 1: Generate embeddings (Port 8001)
    setReloadStatus("Generating embeddings...");
    const generateResponse = await fetch("https://convergeiccc.com/api/generate-embeddings", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (!generateResponse.ok) throw new Error("Failed to generate embeddings");

    const embeddingData = await generateResponse.json();
    console.log("Embedding Generation Response", embeddingData);

    // Update embedding status map directly from embedding response
    if (embeddingData.status === "success" && embeddingData.results) {
      const statusMap = {};
      embeddingData.results.forEach((result) => {
        statusMap[result.id] = {
          status: result.status,
          message: result.message,
        };
      });
      setEmbeddingStatusMap(statusMap);
      
      // Store in sessionStorage
      sessionStorage.setItem("embeddingStatusMap", JSON.stringify(statusMap));
    }

    console.log("Embedding Message", embeddingData.message);
    console.log("Processing Statistics", embeddingData.statistics);

    // Step 2: Reload embeddings (Port 8000)
    setReloadStatus("Reloading embeddings...");
    const reloadResponse = await fetch("https://convergeiccc.com/api/reload-embeddings", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (!reloadResponse.ok) throw new Error("Failed to reload embeddings");

    // Step 3: Check reload status (Port 8000)
    setReloadStatus("Checking reload status...");
    const reloadStatusResponse = await fetch("https://convergeiccc.com/api/reload-status", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!reloadStatusResponse.ok) throw new Error("Failed to check reload status");

    const reloadStatusData = await reloadStatusResponse.json();
    console.log("Reload Status", reloadStatusData);

    setReloadStatus("Images ready for recognition");
    toast.success("Images ready for recognition", { position: "top-center" });
  } catch (error) {
    console.error("Reload Error", error);
    setReloadStatus(`Failed to reload Images: ${error.message}`);
    toast.error(`Failed to reload Images: ${error.message}`, { position: "top-center" });
  } finally {
    setReloadLoading(false);
  }
};


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];

            if (!validImageTypes.includes(file.type)) {
                setErrors((prev) => ({ ...prev, image: "Only image files are allowed (JPEG, PNG)" }));
                setImage(null);
                e.target.value = '';
                return;
            }

            if (file.size > 2 * 1024 * 1024) {
                setErrors((prev) => ({ ...prev, image: "File size should be <= 2 MB" }));
                setImage(null);
                e.target.value = '';
                return;
            }

            setImage(file);
            setExistingImageUrl(null);
            setErrors((prev) => ({ ...prev, image: null }));
        }
    };

    const fileToDataURL = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

    const handleSave = async () => {
        let tempErrors = {};
        if (!firstName.trim()) tempErrors.firstName = "First Name is required";
        if (!lastName.trim()) tempErrors.lastName = "Last Name is required";
        if (!roleType) tempErrors.roleType = "Role/Type is required";
        if (!contactNumber.trim()) tempErrors.contactNumber = "Contact Number is required";
        if (!image && editIndex === null && !existingImageUrl) tempErrors.image = "Image is required";
        if (!department) tempErrors.department = "Department is required";

        if (Object.keys(tempErrors).length > 0) {
            setErrors(tempErrors);
            return;
        }

        const fullName = `${firstName.trim()} ${lastName.trim()}`;

        let imageDataURL;
        let imageFile = null;
        let isNewImage = false;

        if (image && image instanceof File) {
            // New image uploaded
            console.log("📸 Using newly uploaded image");
            imageDataURL = await fileToDataURL(image);
            imageFile = image;
            isNewImage = true;
        } else if (existingImageUrl && editIndex !== null) {
            // Edit mode without new image - just use existing URL for preview
            console.log("ℹ️ Edit mode: Using existing image URL (no new image uploaded)");
            imageDataURL = existingImageUrl;
            imageFile = null;
            isNewImage = false;
        } else if (editIndex !== null && users[editIndex]?.image) {
            // Fallback
            imageDataURL = users[editIndex].image;
            imageFile = null;
            isNewImage = false;
        }

        setPreviewData({
            name: fullName,
            imageDataURL,
            department,
            roleType,
            contactNumber,
            imageFile,
            isNewImage
        });
    };

    const handleConfirmSave = async () => {
        try {
            setLoading(true);
            const fullName = `${firstName.trim()} ${lastName.trim()}`;

            const formData = new FormData();

            const jsonData = {
                personName: fullName,
                department: previewData.department,
                roleType: previewData.roleType,
                contactNumber: previewData.contactNumber,
                status: true,
                ...(editIndex !== null
                    ? { updatedBy: userId }
                    : { createdBy: userId }
                )
            };

            // ✅ Append file OR existing image URL
            if (previewData.isNewImage && previewData.imageFile instanceof File) {
                // New image uploaded - send file
                console.log("✅ Appending NEW image file:", previewData.imageFile.name);
                formData.append('file', previewData.imageFile);
            } else if (editIndex !== null && !previewData.isNewImage && existingImageUrl) {
                // Edit mode without new image - send existing S3 URL
                console.log("ℹ️ Edit mode: Appending existing S3 image URL:", existingImageUrl);
                formData.append('file', null); // Send the S3 URL


            } else if (editIndex === null) {
                console.warn("⚠️ Create mode but no image file found");
            }

            formData.append('data', JSON.stringify(jsonData));

            // Debug: Log FormData contents
            console.log("📦 FormData contents:");
            for (let pair of formData.entries()) {
                if (pair[1] instanceof File) {
                    console.log(`  ${pair[0]}: [FILE] ${pair[1].name} (${pair[1].size} bytes, ${pair[1].type})`);
                } else {
                    console.log(`  ${pair[0]}:`, pair[1]);
                }
            }

            let response;

            if (editIndex !== null && editId !== null) {
                console.log("🔄 UPDATE - Sending to API");
                response = await putDataWithBody(updateimageface.replace('ID', editId), formData, {})
            } else {
                console.log("➕ CREATE - Sending to API");
                response = await postDataWithBody(createimageface, formData, {})
            }

            if (response.status === "success") {
                setPreviewData(null);
                handleReset();
                await fetchAllPersons();
                setActiveTab("view");
                toast.success(response.msg, { position: 'top-center' });
            } else {
                toast.error(response.msg, { position: 'top-center' });
            }
        } catch (error) {
            console.error("API Error:", error);
            toast.error("An error occurred while saving data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancelPreview = () => setPreviewData(null);

    const handleEdit = async (index) => {
        const user = users[index];
        console.log("📝 Editing user:", user);

        const nameParts = user.name.trim().split(' ');
        setFirstName(nameParts[0] || '');
        setLastName(nameParts.slice(1).join(' ') || '');
        setDepartment(user.department || "");
        setRoleType(user.roleType || "");
        setContactNumber(user.contactNumber || "");
        setEditIndex(index);
        setEditId(user.id);

        // Store the existing image URL for preview
        setExistingImageUrl(user.image);
        setImage(null);
        setErrors((prev) => ({ ...prev, image: null }));

        setActiveTab("upload");
    };

    const handleDeleteClick = (index) => {
        const user = users[index];
        setDeleteModal({ show: true, index, user });
    };

    const handleCancelDelete = () => {
        setDeleteModal({ show: false, index: null, user: null });
    };

    const handleConfirmDelete = async () => {
        const { user } = deleteModal;
        if (!user) return;
        try {
            setLoading(true);

            const response = await deleteDataById(deleteperson, user.id);

            if (response.status === "success") {
                setDeleteModal({ show: false, index: null, user: null });
                toast.success(response.msg, { position: 'top-center' });

                try {
                    await fetchAllPersons();
                } catch (fetchError) {
                    console.error("Error refreshing list:", fetchError);
                }
            } else {
                toast.error(response.msg, { position: 'top-center' });
            }
        } catch (error) {
            console.error("Delete Error:", error);
            toast.error("An error occurred while deleting. Please try again.");
        } finally {
            setLoading(false);
            setDeleteModal({ show: false, index: null, user: null });
        }
    };

    const handleFirstNameChange = (e) => {
        const value = e.target.value;
        const regex = /^[a-zA-Z\s]*$/;

        if (regex.test(value)) {
            setFirstName(value);
            if (errors.firstName) {
                setErrors((prev) => ({ ...prev, firstName: "" }));
            }
        } else {
            setErrors((prev) => ({ ...prev, firstName: "Only letters and spaces are allowed" }));
        }
    };

    const handleLastNameChange = (e) => {
        const value = e.target.value;
        const regex = /^[a-zA-Z\s]*$/;

        if (regex.test(value)) {
            setLastName(value);
            if (errors.lastName) {
                setErrors((prev) => ({ ...prev, lastName: "" }));
            }
        } else {
            setErrors((prev) => ({ ...prev, lastName: "Only letters and spaces are allowed" }));
        }
    };

    const handleDepartmentChange = (e) => {
        setDepartment(e.target.value);
        if (errors.department) {
            setErrors((prev) => ({ ...prev, department: "" }));
        }
    };

    const handleRoleTypeChange = (e) => {
        setRoleType(e.target.value);
        if (errors.roleType) {
            setErrors((prev) => ({ ...prev, roleType: "" }));
        }
    };

    const handleContactNumberChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) {
            setContactNumber(value);
            if (errors.contactNumber) {
                setErrors((prev) => ({ ...prev, contactNumber: "" }));
            }
        }
    };

    const handleReset = () => {
        setFirstName("");
        setLastName("");
        setImage(null);
        setDepartment("");
        setErrors({});
        setEditIndex(null);
        setEditId(null);
        setExistingImageUrl(null);
        setRoleType("");
        setContactNumber("");
    };

    // Helper function to get image quality status
    const getImageQualityStatus = (userId) => {
        const statusInfo = embeddingStatusMap[userId];
        if (!statusInfo) return null;
        
        return {
            status: statusInfo.status,
            message: statusInfo.message
        };
    };


    return (
        <div className="container mt-4 fm-registration-root">
            {/* Tabs */}
            <div style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <ul className="nav mb-0 fm-tabs" style={{ border: 'none' }}>
                        <li className="nav-item">
                            <button
                                className={`fm-tab-btn${activeTab === "upload" ? " fm-tab-btn--active" : ""}`}
                                onClick={() => setActiveTab("upload")}
                            >
                                Register
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`fm-tab-btn${activeTab === "view" ? " fm-tab-btn--active" : ""}`}
                                onClick={() => setActiveTab("view")}
                            >
                                View
                            </button>
                        </li>
                    </ul>
                    {activeTab === "view" && (
                        <button
                            className="fm-btn-reload"
                            onClick={() => setReloadConfirmModal(true)}
                            disabled={reloadLoading}
                            style={{ padding: '8px 20px', minWidth: '120px' }}
                        >
                            {reloadLoading ? (
                                <>
                                    <div className="spinner-border spinner-border-sm" role="status" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.5)', borderTopColor: '#fff' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <span>Reloading...</span>
                                </>
                            ) : (
                                <>
                                    <i className="bi bi-arrow-clockwise" style={{marginLeft:"-20px"}}></i>
                                    <span>Reload</span>
                                </>
                            )}
                        </button>
                    )}
                </div>
                {activeTab === "view" && (
                    <div className="fm-reload-note" style={{ textAlign: 'right', marginTop: '6px' }}>
                        <i className="bi bi-info-circle" style={{ marginRight: '4px' }}></i>
                        (After saving the registration form click reload for image recognition)
                    </div>
                )}
            </div>

            {/* Upload Section */}
            {activeTab === "upload" && (
                <div className="card p-4 shadow-sm fm-form-card">
                    <h5 className="fm-form-title">Facial Recognition Registration</h5>

                    {/* Name field */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">
                                First Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                                placeholder="Enter first name"
                                value={firstName}
                                onChange={handleFirstNameChange}
                            />
                            {errors.firstName && (
                                <div className="invalid-feedback">{errors.firstName}</div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">
                                Last Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                                placeholder="Enter last name"
                                value={lastName}
                                onChange={handleLastNameChange}
                            />
                            {errors.lastName && (
                                <div className="invalid-feedback">{errors.lastName}</div>
                            )}
                        </div>
                    </div>

                    {/* Role and Department */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">
                                Role / Type <span className="text-danger">*</span>
                            </label>
                            <select
                                className={`form-select ${errors.roleType ? "is-invalid" : ""}`}
                                value={roleType}
                                onChange={handleRoleTypeChange}
                            >
                                <option value="">Select Role</option>
                                <option value="Student">Student</option>
                                <option value="Faculty">Faculty</option>
                                <option value="Staff">Staff</option>
                                <option value="Visitor">Visitor</option>
                                <option value="Contractor">Contractor</option>
                            </select>
                            {errors.roleType && (
                                <div className="invalid-feedback">{errors.roleType}</div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">
                                Department <span className="text-danger">*</span>
                            </label>
                            <select
                                className={`form-select ${errors.department ? "is-invalid" : ""}`}
                                value={department}
                                onChange={handleDepartmentChange}
                            >
                                <option value="">Select Department</option>
                                <option value="HR">HR</option>
                                <option value="Engineering">Engineering</option>
                                <option value="Marketing">Marketing</option>
                                <option value="Sales">Sales</option>
                                <option value="IT">IT</option>
                            </select>
                            {errors.department && (
                                <div className="invalid-feedback">{errors.department}</div>
                            )}
                        </div>
                    </div>

                    {/* Contact Number and Image Upload */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">
                                Contact Number <span className="text-danger">*</span>
                            </label>
                            <input
                                type="tel"
                                className={`form-control ${errors.contactNumber ? "is-invalid" : ""}`}
                                placeholder="Enter contact number"
                                value={contactNumber}
                                onChange={handleContactNumberChange}
                                maxLength="10"
                            />
                            {errors.contactNumber && (
                                <div className="invalid-feedback">{errors.contactNumber}</div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">
                                Upload Image <span className="text-danger">*</span>
                                {/* {editIndex !== null && existingImageUrl && (
                                    <span className="text-muted small"> (Leave empty to keep current image)</span>
                                )} */}
                            </label>
                            <div className="custom-file-input-wrapper">
                                <input
                                    type="file"
                                    id="imageInput"
                                    className="d-none"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                                <label
                                    htmlFor="imageInput"
                                    className={`form-control d-flex align-items-center justify-content-between ${errors.image ? "is-invalid" : ""}`}
                                    style={{ cursor: 'pointer', minHeight: '38px' }}
                                >
                                    <span className={image || existingImageUrl ? "text-dark" : "text-muted"}>
                                        {image ?
                                            image.name :
                                            (existingImageUrl ?
                                                `${users[editIndex]?.fileName || 'existing-image.jpg'}` :
                                                "Choose file..."
                                            )
                                        }
                                    </span>
                                    <span className="text-muted">Browse</span>
                                </label>
                            </div>
                            {errors.image && (
                                <div className="invalid-feedback d-block">{errors.image}</div>
                            )}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex gap-2 mt-3">
                        <button
                            className="fm-btn-primary"
                            onClick={handleSave}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : (editIndex !== null ? "Update" : "Save")}
                        </button>

                        <button
                            className="fm-btn-secondary"
                            onClick={handleReset}
                            disabled={loading}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            )}

            {/* View Section */}
            {activeTab === "view" && (
    <div style={{ position: 'relative', minHeight: '400px' }}>
                    {loading ? (
                        <div className="text-center mt-4">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="d-flex flex-wrap justify-content-left gap-2 mt-4">
                                {users.length === 0 ? (
                                    <p className="text-muted text-center">No records found.</p>
                                ) : (
                                    users.map((user, index) => {
                                        const qualityStatus = getImageQualityStatus(user.id);
                                        
                                        return (
                                            <div key={user.id} className="card p-3 shadow-sm fm-user-card" style={{
                                                width: "200px",
                                                display: "flex",
                                                flexDirection: "column",
                                                minHeight: "420px"
                                            }}>
                                                <img
                                                    src={user.image}
                                                    alt={user.name}
                                                    className="img-fluid rounded mb-2 fm-user-img"
                                                    style={{
                                                        height: "150px",
                                                        width: "100%",
                                                        objectFit: "cover",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => handleImageClick(user.image, user.name)}
                                                    onError={(e) => {
                                                        e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                                                    }}
                                                />

                                                <h6 className="mb-2 fm-user-name">{user.name}</h6>
                                                <p className="small mb-2 fm-user-info">
                                                    {user.department || "null"}, {user.roleType || "null"}, {user.contactNumber || "null"}
                                                </p>
                                                
                                                {/* Image Quality Status Badge - Flexible space */}
                                                <div style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
                                                    {qualityStatus && (
                                                        <div
                                                            className={`mb-2 p-2 rounded mt-auto ${qualityStatus.status === 'success' ? 'fm-quality-success' : 'fm-quality-error'}`}
                                                        >
                                                            <div style={{
                                                                fontWeight: '600',
                                                                color: qualityStatus.status === 'success' ? '#065f46' : '#991b1b',
                                                                marginBottom: '2px'
                                                            }}>
                                                                Image Quality:
                                                            </div>
                                                            <div style={{
                                                                color: qualityStatus.status === 'success' ? '#065f46' : '#991b1b',
                                                                wordWrap: 'break-word'
                                                            }}>
                                                                {qualityStatus.message}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Action Buttons - Fixed at bottom using mt-auto (shown per role's Edit / Delete permission) */}
                                                {(canEdit || canDelete) && <div className="d-flex gap-2 mt-auto">
                                                    {canEdit && <button
                                                        className="fm-action-btn--edit"
                                                        style={{
                                                            width: '34px',
                                                            height: '34px',
                                                            minWidth: '34px',
                                                            borderRadius: '50%',
                                                            background: '#e0e7ff',
                                                            border: '1.5px solid #a5b4fc',
                                                            display: 'grid',
                                                            placeItems: 'center',
                                                            padding: '0',
                                                            cursor: 'pointer',
                                                            flexShrink: 0,
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onClick={() => handleEdit(index)}
                                                        disabled={loading}
                                                    >
                                                        <i className="bi bi-pencil" style={{ color: "#6366f1", fontSize: "14px", lineHeight: '1', display: 'block', marginLeft:"-21px" }}></i>
                                                    </button>}

                                                    {canDelete && <button
                                                        className="fm-action-btn--delete"
                                                        style={{
                                                            width: '34px',
                                                            height: '34px',
                                                            minWidth: '34px',
                                                            borderRadius: '50%',
                                                            background: '#fee2e2',
                                                            border: '1.5px solid #fca5a5',
                                                            display: 'grid',
                                                            placeItems: 'center',
                                                            padding: '0',
                                                            cursor: 'pointer',
                                                            flexShrink: 0,
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onClick={() => handleDeleteClick(index)}
                                                        disabled={loading}
                                                    >
                                                        <i className="bi bi-trash" style={{ color: "#ef4444", fontSize: "14px", lineHeight: '1', display: 'block', marginLeft:"-21px" }}></i>
                                                    </button>}
                                                </div>}
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </>
                    )}

                    {/* Reload Status Indicator - Keep fixed for notifications
                    {reloadStatus && (
                        <div
                            style={{
                                position: 'fixed',
                                bottom: '30px',
                                right: '30px',
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                color: 'white',
                                padding: '10px 20px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                zIndex: 999,
                                maxWidth: '250px',
                                textAlign: 'center'
                            }}
                        >
                            {reloadStatus}
                        </div>
                    )} */}
                </div>
            )}

            {/* Preview Modal */}
            {previewData && (
                <div
                    className="modal fade show fm-modal-enhanced"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Your Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCancelPreview}
                                    disabled={loading}
                                />
                            </div>
                            <div className="modal-body text-center">
                                <h6>{previewData.name}</h6>
                                <div>
                                    <p className="text-muted d-inline me-3">{previewData.department},</p>
                                    <p className="text-muted d-inline me-3">{previewData.roleType},</p>
                                    <p className="text-muted d-inline">{previewData.contactNumber}</p>
                                </div>
                                <img
                                    src={previewData.imageDataURL}
                                    alt="preview"
                                    className="img-fluid rounded"
                                    style={{ maxHeight: "300px" }}
                                />
                            </div>
                            <div className="modal-footer" style={{
                                padding: "5px",
                                borderTop: "1px solid #dee2e6",
                                margin: 0,
                                justifyContent: "flex-end",
                            }}>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleCancelPreview}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleConfirmSave}
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Confirm & Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {deleteModal.show && (
                <div
                    className="modal fade show fm-modal-enhanced"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Delete</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCancelDelete}
                                    disabled={loading}
                                />
                            </div>
                            <div className="modal-body text-center">
                                {deleteModal.user && (
                                    <>
                                        <img
                                            src={deleteModal.user.image}
                                            alt={deleteModal.user.name}
                                            className="img-fluid rounded mb-3"
                                            style={{ maxHeight: "200px", objectFit: "cover" }}
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                                            }}
                                        />
                                        <p className="text-muted mb-1"><strong>{deleteModal.user.name}</strong></p>
                                        <p className="text-muted small">{deleteModal.user.department}, {deleteModal.user.roleType}, {deleteModal.user.contactNumber}</p>
                                        <h6 style={{ color: 'red' }}>Are you sure you want to delete?</h6>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={handleCancelDelete}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={handleConfirmDelete}
                                    disabled={loading}
                                >
                                    {loading ? "Deleting..." : "Delete"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Image Preview Modal */}
{imagePreviewModal.show && (
    <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.85)" }}
        tabIndex="-1"
        onClick={handleCloseImagePreview}
    >
        <div 
            className="modal-dialog modal-dialog-centered modal-lg"
            style={{ marginLeft: "auto", marginRight: "7%",maxHeight: "70vh" }}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="modal-content" style={{ backgroundColor: "transparent", border: "none" }}>
                <div className="modal-header" style={{ 
                    border: "none", 
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "8px 8px 0 0"
                }}>
                    <h5 className="modal-title">{imagePreviewModal.userName}</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleCloseImagePreview}
                    />
                </div>
                <div className="modal-body text-center" style={{ 
                    padding: 0,
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: "0 0 8px 8px"
                }}>
                    <img
                        src={imagePreviewModal.imageUrl}
                        alt={imagePreviewModal.userName}
                        className="img-fluid"
                        style={{ 
                            maxHeight: "50vh", 
                            width: "auto",
                            objectFit: "contain"
                        }}
                        onError={(e) => {
                            e.target.src = 'https://via.placeholder.com/400?text=Image+Not+Found';
                        }}
                    />
                </div>
            </div>
        </div>
    </div>
)}
{/* Reload Confirmation Modal */}
{reloadConfirmModal && (
    <div
        className="modal fade show fm-modal-enhanced"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        tabIndex="-1"
    >
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Confirm Reload</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setReloadConfirmModal(false)}
                        disabled={reloadLoading}
                    />
                </div>
                <div className="modal-body text-center">
                    <i className="bi bi-exclamation-circle text-warning" style={{ fontSize: '48px' }}></i>
                    <h6 className="mt-3">Are you sure you want to reload the images?</h6>
                    <p className="text-muted">This will recreate all face recognition images.</p>
                </div>
                <div className="modal-footer">
                    <button
                        className="btn btn-secondary"
                        style={{marginTop:"32px",height:"36px",fontSize:"12px"}}
                        onClick={() => setReloadConfirmModal(false)}
                        disabled={reloadLoading}
                    >
                        No
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            setReloadConfirmModal(false);
                            handleReloadEmbeddings();
                        }}
                        disabled={reloadLoading}
                    >
                        {reloadLoading ? "Processing..." : "Yes"}
                    </button>
                </div>
            </div>
        </div>
    </div>
)}


        </div>
    );
};

export default UserImagesView;